/* RINCE — druppels-op-glas overlay.
   Genereert statische condensdruppels + enkele glijdende druppels in elke
   [data-rx-drops] container. Licht (geen canvas, geen per-frame JS): de
   glijders zijn pure CSS-animaties, alleen actief wanneer de sectie in beeld
   is (IntersectionObserver) en uitgeschakeld bij prefers-reduced-motion. */
(function () {
  'use strict';
  if (window.__rxDropsInit) return;
  window.__rxDropsInit = true;

  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function build(host) {
    if (host.dataset.armed) return;
    host.dataset.armed = '1';

    // de overlay vult zijn ouder; die moet gepositioneerd zijn
    var parent = host.parentElement;
    if (parent && getComputedStyle(parent).position === 'static') parent.style.position = 'relative';

    var density = host.dataset.density || 'medium';
    var N = density === 'high' ? 84 : density === 'low' ? 30 : 54;
    var runners = reduced ? 0 : (density === 'high' ? 5 : density === 'low' ? 2 : 3);

    var frag = document.createDocumentFragment();
    var lenses = 0, MAX_LENS = 10; // backdrop-filter is prijzig: alleen op enkele grote druppels
    for (var i = 0; i < N; i++) {
      var d = document.createElement('i');
      d.className = 'rx-drop';
      // natuurlijke verdeling: veel kleintjes, weinig grote (kwadratisch gewogen)
      var t = Math.random();
      var s = 2 + t * t * 12;                        // 2–14 px, zwaartepunt klein
      if (s > 8 && lenses < MAX_LENS) { d.className += ' rx-drop--lens'; lenses++; }
      d.style.width = s.toFixed(1) + 'px';
      d.style.height = (s * (1.05 + Math.random() * 0.35)).toFixed(1) + 'px';
      d.style.left = (Math.random() * 100).toFixed(2) + '%';
      d.style.top = (Math.random() * 100).toFixed(2) + '%';
      d.style.opacity = (0.30 + Math.random() * 0.5).toFixed(2);
      // kleine rotatie zodat druppels niet allemaal identiek hangen
      d.style.transform = 'rotate(' + ((Math.random() * 10) - 5).toFixed(1) + 'deg)';
      frag.appendChild(d);
    }
    for (var r = 0; r < runners; r++) {
      var w = document.createElement('i');
      w.className = 'rx-drop rx-drop--run ' + (Math.random() < 0.5 ? 'rx-drop--runA' : 'rx-drop--runB');
      var s2 = 7 + Math.random() * 6;
      w.style.width = s2.toFixed(1) + 'px';
      w.style.height = (s2 * 1.4).toFixed(1) + 'px';
      w.style.left = (5 + Math.random() * 90).toFixed(2) + '%';
      w.style.setProperty('--run-dur', (11 + Math.random() * 10).toFixed(1) + 's');
      w.style.setProperty('--run-delay', (Math.random() * 14).toFixed(1) + 's');
      w.style.setProperty('--jx', ((Math.random() * 36) - 18).toFixed(0) + 'px'); // zijwaartse drift
      frag.appendChild(w);
    }
    host.appendChild(frag);

    function setRunHeight() { host.style.setProperty('--run-h', (host.clientHeight || 600) + 'px'); }
    setRunHeight();
    window.addEventListener('resize', setRunHeight, { passive: true });

    if ('IntersectionObserver' in window) {
      var ioFired = false;
      var io = new IntersectionObserver(function (es) {
        ioFired = true;
        es.forEach(function (e) { host.classList.toggle('is-inview', e.isIntersecting); });
      }, { rootMargin: '80px' });
      io.observe(host);
      // vangnet: meldt IO zich niet (embedded/preview-contexten), dan gewoon aan —
      // zichtbaarheid is hier alleen een optimalisatie, geen vereiste
      setTimeout(function () { if (!ioFired) host.classList.add('is-inview'); }, 1200);
    } else {
      host.classList.add('is-inview');
    }
  }

  function boot() {
    document.querySelectorAll('[data-rx-drops]').forEach(build);
  }
  document.addEventListener('shopify:section:load', boot);
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
